import React, { lazy } from 'react';
import { RouteConfig } from 'react-router-config';
import IconNet from '@/assets/images/menu/icon-net.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';

export const trafficRoutes = (): RouteConfig[] => [
  {
    path: '/traffic',
    name: '流量',
    icon: <MenuIcon icon={IconNet} fontSize={16} />,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.VisionOS,
    ],
    sort: 90,
    routes: [
      {
        path: '/traffic/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/traffic/analytics')),
      },
      {
        path: '/traffic/issues/detail',
        name: '异常详情',
        component: lazy(() => import('@/presentation/pages/traffic/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/traffic/issues/case',
        name: '异常个例详情',
        component: lazy(() => import('@/presentation/pages/traffic/issues/case')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/traffic/issues',
        name: '异常分析',
        component: lazy(() => import('@/presentation/pages/traffic/issues/list')),
      },
    ],
  },
];

export default trafficRoutes;
